/* eslint-disable @typescript-eslint/no-explicit-any */
export const sendGlobalData = (newData: any) => {
  window.masterLayoutProps = {
    ...window.masterLayoutProps,
    ...newData,
  };
  const event = new CustomEvent('masterLayoutProps');
  window.dispatchEvent(event);
};
